import Vue from 'vue';
import Vuex from 'vuex';
import { router } from '../main.js';
import Game from '../game/game';

Vue.use(Vuex);

const game = new Game();

const state = {
  selectedPlayers: 2,
  selectedDifficulty: 'average',
  selectedJokers: true,
  players: [],
  tableStock: [],
  tableStockHidden: [],
  tableCards: []
};

const actions = {
  setSelectedPlayers({ commit }, number) {
    commit('selectPlayers', number);
  },
  setSelectedDifficulty({ commit }, value) {
    commit('selectDifficulty', value);
  },
  setSelectedJokers({ commit }, bool) {
    commit('selectJokers', bool);
  },
  setPlayers({ commit }, players) {
    commit('setPlayers', players);
  },
  setTableCards({ commit }) {
    commit('setTableCards');
  },
  setTableStock({ commit }, cards) {
    commit('setTableStock', cards);
  },
  setTableStockHidden({ commit }, position) {
    commit('setTableStockHidden', position);
  },
  nextPlayer({ commit, state, getters }) {
    const currentIndex = state.players.findIndex(player => player.active);
    const nextIndex = (currentIndex + 1) % state.players.length;

    commit('nextPlayer', {
      oldPlayerIndex: currentIndex,
      newPlayerIndex: nextIndex
    });

    if (state.players[getters.currentPlayerIndex].inHand.length < 5) {
      commit('getFromStock', { index: getters.currentPlayerIndex });
    }
  },
  setPutAway({ commit, getters, dispatch }, { card, toPosition }) {
    commit('setPutAway', {
      card,
      toPosition,
      index: getters.currentPlayerIndex
    });

    dispatch('nextPlayer');
  },
  setTableCardFromHand({ commit, state, getters }, { card, toPosition }) {
    commit('setTableCardFromHand', {
      card,
      toPosition,
      index: getters.currentPlayerIndex
    });

    if (!state.players[getters.currentPlayerIndex].inHand.length) {
      commit('getFromStock', { index: getters.currentPlayerIndex });
    }

    if (state.tableCards[toPosition].cards.length >= 12) {
      commit('setTableStockHidden', toPosition);
    }
  },
  setTableCardFromStock({ commit, getters }, { card, toPosition }) {
    commit('setTableCardFromStock', {
      card,
      toPosition,
      index: getters.currentPlayerIndex
    });

    if (!state.players[getters.currentPlayerIndex].stock.length) {
      router.push('einde');
    }

    if (state.tableCards[toPosition].cards.length >= 12) {
      commit('setTableStockHidden', toPosition);
    }
  },
  setTableCardFromPutAway(
    { commit, getters },
    { card, toPosition, fromPosition }
  ) {
    commit('setTableCardFromPutAway', {
      card,
      toPosition,
      fromPosition,
      index: getters.currentPlayerIndex
    });

    if (state.tableCards[toPosition].cards.length >= 12) {
      commit('setTableStockHidden', toPosition);
    }
  }
};

const mutations = {
  selectPlayers(state, number) {
    state.selectedPlayers = number;
  },
  selectDifficulty(state, value) {
    state.selectedDifficulty = value;
  },
  selectJokers(state, bool) {
    state.selectedJokers = bool;
  },
  setPlayers(state, players) {
    state.players = players;
  },
  setTableCards(state) {
    Vue.set(state, 'tableCards', [
      {
        nextNumber: 1,
        cards: []
      },
      {
        nextNumber: 1,
        cards: []
      },
      {
        nextNumber: 1,
        cards: []
      },
      {
        nextNumber: 1,
        cards: []
      }
    ]);
  },
  nextPlayer: (state, { oldPlayerIndex, newPlayerIndex }) => {
    Vue.set(state.players[oldPlayerIndex], 'active', false);
    Vue.set(state.players[newPlayerIndex], 'active', true);
  },
  setTableStock(state, cards) {
    state.tableStock = cards;
  },
  setTableStockHidden(state, toPosition) {
    const moveToHiddenStock = state.tableCards[toPosition].cards;
    Vue.set(state, 'tableStockHidden', [
      ...state.tableStockHidden,
      ...moveToHiddenStock
    ]);
    Vue.set(state.tableCards[toPosition], 'cards', []);
    Vue.set(state.tableCards[toPosition], 'nextNumber', 1);
  },
  setPutAway(state, { card, toPosition, index }) {
    Vue.set(
      state.players[index],
      'inHand',
      state.players[index].inHand.filter(
        inHandCard => inHandCard.key !== card.key
      )
    );
    state.players[index].putAway[toPosition].push(card);
  },
  setTableCardFromHand(state, { card, toPosition, index }) {
    Vue.set(
      state.players[index],
      'inHand',
      state.players[index].inHand.filter(
        inHandCard => inHandCard.key !== card.key
      )
    );

    state.tableCards[toPosition].cards.push(card);
    state.tableCards[toPosition].nextNumber += 1;
  },
  setTableCardFromStock(state, { card, toPosition, index }) {
    Vue.set(
      state.players[index],
      'stock',
      state.players[index].stock.filter(stockCard => stockCard.key !== card.key)
    );

    state.tableCards[toPosition].cards.push(card);
    state.tableCards[toPosition].nextNumber += 1;
  },
  setTableCardFromPutAway(state, { card, toPosition, fromPosition, index }) {
    Vue.set(state.players[index].putAway, fromPosition, [
      ...state.players[index].putAway[fromPosition].filter(
        putAwayCard => putAwayCard.key !== card.key
      )
    ]);

    state.tableCards[toPosition].cards.push(card);
    state.tableCards[toPosition].nextNumber += 1;
  },
  getFromStock(state, { index }) {
    const countFromStock = 5 - state.players[index].inHand.length;

    if (countFromStock >= state.tableStock.length) {
      const newTableStockCards = game.shuffle(state.tableStockHidden);

      Vue.set(state, 'tableStock', [
        ...state.tableStock,
        ...newTableStockCards
      ]);

      Vue.set(state, 'tableStockHidden', []);
    }

    const cardFromStocks = [
      ...state.tableStock.slice(state.tableStock.length - countFromStock)
    ];

    Vue.set(state.players[index], 'inHand', [
      ...state.players[index].inHand,
      ...cardFromStocks
    ]);

    Vue.set(
      state,
      'tableStock',
      state.tableStock.filter(item => !cardFromStocks.includes(item))
    );
  }
};

const getters = {
  currentPlayerIndex: state => {
    return state.players.findIndex(player => player.active);
  },
  amountTableStock: state => {
    return state.tableStock.length;
  },
  winnerPlayer: state => {
    return state.players.find(player => !player.stock.length);
  }
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  strict: process.env.NODE_ENV !== 'production'
});
